import React from 'react';
import { ReportingOverviewTotals } from '../../services/api';

interface Props {
  totals: ReportingOverviewTotals;
}

function fmt(n: number): string {
  return n.toLocaleString();
}

function fmtPct(p: number): string {
  return (p * 100).toFixed(1) + '%';
}

/**
 * Four-card KPI row, aligned with the dashboard's spine-outcome definitions
 * so the same words mean the same number everywhere:
 *
 *   Leads In | Passed Spine | Failed | Spine Pass Rate
 *
 * Leads In      = leads that passed the door into the spine.
 * Passed Spine  = cleared every vertebra and reached the legs (Leads In − Failed).
 * Failed        = filtered out by a vertebra (matches dashboard "Failed").
 * Spine Pass Rate = Passed Spine / Leads In.
 */
export default function KpiCards({ totals }: Props) {
  const cards = [
    { label: 'Leads In',        value: fmt(totals.leadsIn),     color: '#111827', bg: '#f9fafb' },
    { label: 'Passed Spine',    value: fmt(totals.passedSpine), color: '#1d4ed8', bg: '#eff6ff' },
    { label: 'Failed',          value: fmt(totals.failed),      color: '#b91c1c', bg: '#fef2f2' },
    { label: 'Spine Pass Rate', value: fmtPct(totals.passRate), color: '#047857', bg: '#ecfdf5' },
  ];
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      gap: 12,
    }}>
      {cards.map(c => (
        <div key={c.label} style={{
          padding: '18px 20px',
          background: c.bg,
          border: '1px solid #e5e7eb',
          borderRadius: 8,
        }}>
          <div style={{ fontSize: 12, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, fontWeight: 600 }}>
            {c.label}
          </div>
          <div style={{ marginTop: 6, fontSize: 28, fontWeight: 700, color: c.color }}>
            {c.value}
          </div>
        </div>
      ))}
    </div>
  );
}
